import fp from "lodash/fp";

import { ExecutiveProductReviewNameFields } from "globalConstants";
import { deleteEmptyValues } from "mappers";

export const getMappedProductReviewForm = formValues => {
	const { website, comment } = ExecutiveProductReviewNameFields;

	return fp.flow(formValues => {
		const mappedValues = {
			website: formValues?.[website] || null,
			comments: formValues?.[comment] || null,
		};

		return mappedValues;
	}, fp.tap(deleteEmptyValues))(formValues);
};
